import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DatePipe } from '@angular/common';
import { ClientsComponent } from './components/clients/clients.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { NavigationComponent } from './components/navigation/navigation.component';
import { UserAdministratorsComponent } from './components/user-administrators/user-administrators.component';
import { MaterialModule } from './material/material/material.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { RrelinkingComponent } from './components/rrelinking/rrelinking.component';
import { AdjusterManagementComponent } from './components/adjuster-management/adjuster-management.component';
import { ApirequestresponseinfoComponent } from './components/api-request-response-info/api-request-response-info.component';
import { ClaimReassignmentComponent } from './components/claimreassignment/claim-reassignment.component';
import { DataloadmanagementComponent } from './components/dataloadmanagement/dataloadmanagement.component';
import { QatoolsComponent } from './components/qatools/qatools.component';
import { RecoveryagentsComponent } from './components/recoveryagents/recoveryagents.component';
import { RreManagementComponent } from './components/rremanagement/rremanagement.component';
import { ServicemanagementComponent } from './components/servicemanagement/servicemanagement.component';
import { TpaRreManagementComponent } from './components/tparremanagement/tparremanagement.component';
import { AddservicedialogComponent } from './components/servicemanagement/addservicedialog/addservicedialog.component';
import { DeleteconfirmationdialogComponent } from './components/deleteconfirmationdialog/deleteconfirmationdialog.component';
import { EditfileauthorizationComponent } from './components/dataloadmanagement/editfileauthorization/editfileauthorization.component';
import { RecoveryAgentModalComponent } from './components/recoveryagents/recovery-agent-modal/recovery-agent-modal.component';
import { RecoveryAgentViewModalComponent } from './components/recoveryagents/recovery-agent-view-modal/recovery-agent-view-modal.component';
import { RreLinkModalComponent } from './components/rrelinking/rre-link-modal/rre-link-modal.component';
import { AutocompleteSuffixActionsComponent } from './shared/components/autocomplete-suffix-actions/autocomplete-suffix-actions.component';
import { RreManagementModalComponent } from './components/rremanagement/rre-management-modal/rre-management-modal.component';
import { TpaRreManagementModalComponent } from './components/tparremanagement/tpa-rre-management-modal/tpa-rre-management-modal.component';
import { RestApiRequestResponseDetailsComponent } from './components/rest-api-request-response-details/rest-api-request-response-details.component';
import { ClearStaleSelectionOnOpenDirective } from './shared/directives/clear-stale-selection-on-open.directive';
import { SftpMigrationConfigurationComponent } from './components/sftp-migration-configuration/sftp-migration-configuration.component';
import { FileMovementLogsComponent } from './components/file-movement-logs/file-movement-logs.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ClientsComponent,
    FooterComponent,
    HeaderComponent,
    NavigationComponent,
    UserAdministratorsComponent,
    NotificationsComponent,
    RrelinkingComponent,
    AdjusterManagementComponent,
    ApirequestresponseinfoComponent,
    ClaimReassignmentComponent,
    DataloadmanagementComponent,
    QatoolsComponent,
    RecoveryagentsComponent,
    RreManagementComponent,
    ServicemanagementComponent,
    TpaRreManagementComponent,
    RecoveryAgentModalComponent,
    RecoveryAgentViewModalComponent,
    RreLinkModalComponent,
    AutocompleteSuffixActionsComponent,
    RreManagementModalComponent,
    TpaRreManagementModalComponent,
    AddservicedialogComponent,
    DeleteconfirmationdialogComponent,
    EditfileauthorizationComponent,
    RestApiRequestResponseDetailsComponent,
    SftpMigrationConfigurationComponent,
    FileMovementLogsComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    NgxSpinnerModule,
    MaterialModule,
    ClearStaleSelectionOnOpenDirective,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [DatePipe, provideHttpClient(withInterceptorsFromDi())],
})
export class AppModule {}
